module.exports = __webpack_public_path__ + "img/face-eyes-xmarks.9794a46c.svg";